import React from 'react';
import { Icon } from '../Icon';
import type { IconProps } from '../.types/IconPropsType';

export function StarIcon(props: IconProps) {
  return (
    <Icon {...props}>
      <svg
        width="16px"
        height="16px"
        viewBox="0 0 12 12"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        pointerEvents="none"
      >
        <path
          pointerEvents="none"
          d="M11.572 4.27L8.032 3.756L6.448 0.548C6.40211 0.469358 6.33642 0.404115 6.25746 0.358771C6.17851 0.313427 6.08905 0.289566 5.998 0.289566C5.90695 0.289566 5.81749 0.313427 5.73853 0.358771C5.65958 0.404115 5.59389 0.469358 5.548 0.548L3.968 3.756L0.428 4.27C0.33565 4.28341 0.248896 4.3224 0.177553 4.38255C0.106209 4.44271 0.0531235 4.52162 0.0243012 4.61038C-0.00452111 4.69914 -0.00792966 4.79419 0.0144611 4.88478C0.0368519 4.97537 0.0841484 5.05789 0.151 5.123L2.713 7.623L2.107 11.149C2.09118 11.241 2.10144 11.3356 2.13662 11.4221C2.17179 11.5086 2.23049 11.5835 2.30605 11.6384C2.38161 11.6932 2.47102 11.7258 2.56415 11.7325C2.65728 11.7391 2.75041 11.7196 2.833 11.676L6 10.008L9.167 11.673C9.23842 11.7109 9.31814 11.7305 9.399 11.73C9.47186 11.7302 9.54388 11.7144 9.61001 11.6838C9.67614 11.6532 9.73479 11.6085 9.78185 11.5529C9.82891 11.4973 9.86324 11.432 9.88244 11.3618C9.90164 11.2915 9.90524 11.2178 9.893 11.146L9.287 7.62L11.849 5.12C11.9159 5.05489 11.9631 4.97237 11.9855 4.88178C12.0079 4.79119 12.0045 4.69614 11.9757 4.60738C11.9469 4.51862 11.8938 4.43971 11.8224 4.37955C11.7511 4.3194 11.6643 4.28041 11.572 4.267V4.27Z"
          fill="#F5D63D"
        />
      </svg>
    </Icon>
  );
}
